<template>
  <div>
    <b-form-select v-model="category" :options="categories_select" data-live-search="true" class="mb-3">
      <template slot="first">
        <option v-if="newTicket" :value="null" selected disabled>-- Selecciona una categoria --</option>
      </template>
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: {
    newTicket: {
      required: false,
      type: Boolean
    },
    categoria: {
      required: false,
      type: Object
    },
    resetear: {
      required: false,
      type: Boolean
    }
  },
  computed: {
    categories () {
      return this.$store.state.categories
    }
  },
  data () {
    return {
      selected: null,
      // Arrays del select
      categories_select: [],
      // Información escogida por el usuario
      category: this.categoria ? this.categoria.id : null
    }
  },
  created () {
    this.$store.dispatch('fetchCategories').then(() => {
      this.categories_select = this.categories.map(categoria =>
        ({
          value: categoria.id,
          text: categoria.descripcio
        }))
      return this.categories_select
    }, {})
  },
  watch: {
    resetear: function (newVal) {
      if (newVal === true) {
        this.category = null
      }
    },
    // Cuando seleccione una categoria filtramos y aviso al elemento parent para que pille la info
    category: function (newId) {
      if (newId != null) {
        this.$emit('changeCategory', {
          id: newId,
          descripcio: this.category.descripcio
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
